"use client";

import React from "react";
import { X } from "lucide-react";
import Image from "next/image";

interface DocumentPreviewModalProps {
	file: File;
	previewUrl: string;
	onClose: () => void;
}

const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
	file,
	previewUrl,
	onClose,
}) => {
	return (
		<div
			className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1200] p-4"
			onClick={onClose}>
			<div
				className="bg-white w-full max-w-2xl h-[80vh] rounded-lg shadow-lg relative overflow-hidden flex flex-col"
				onClick={(event) => event.stopPropagation()}>
				<div className="flex justify-between items-center border-b p-4">
					<h2 className="text-lg font-semibold text-black">File Preview</h2>
					<button onClick={onClose} className="cursor-pointer">
						<X size={18} />
					</button>
				</div>
				<div className="flex-1 overflow-hidden">
					{file?.type.startsWith("image/") ? (
						<Image
							src={previewUrl}
							alt="Preview"
							className="w-full h-full object-contain"
							width={500}
							height={500}
						/>
					) : file?.type === "application/pdf" ? (
						<iframe
							src={previewUrl}
							className="w-full h-full"
							title="PDF Preview"
						/>
					) : (
						<div className="flex items-center justify-center h-full text-center text-gray-600 text-sm">
							Preview not available for this file type.
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DocumentPreviewModal;
